import { render, staticRenderFns } from "./TagSelectOptions.vue?vue&type=template&id=2006f3e8&scoped=true&"
import script from "./TagSelectOptions.vue?vue&type=script&lang=js&"
export * from "./TagSelectOptions.vue?vue&type=script&lang=js&"
import style0 from "./TagSelectOptions.vue?vue&type=style&index=0&id=2006f3e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006f3e8",
  null
  
)

export default component.exports